import { IAppState } from "../../../../modules/reducers";

export const getT2SLoaded = (state: IAppState): boolean => state.t2s.t2sLoaded;
